/* eslint-disable max-len */
export const OffersIndex = "/okazje";
export const Offers = { url: "/api/offers/%7Baction%7D", type: undefined as { action: string | number; } };
